import React from "react";
import {
  ClientMenu,
  SecondaryNavClient,
} from "../../../components/AdminComponents/MenuItems";
import SecondaryNav from "../../../components/AdminComponents/SecondaryNav";
import Sidebar from "../../../components/AdminComponents/SideNav";
import { useParams } from "react-router-dom";
import UsersTable from "../../../components/AdminComponents/UsersTable";

import { useSelector } from "react-redux";
import DetailsContainer from "../../../components/DetailsContainer";

const ClientRelationships = () => {
  const { id } = useParams();
  const namingData = useSelector((state) => state.orgdeatil);
  const namingDetails = [
    { label: "Client ID", value: namingData?.id },
    { label: "Client Name", value: namingData?.name },
  ];
  return (
    <div>
      <Sidebar props={ClientMenu}>
        <SecondaryNav menuItems={SecondaryNavClient} id={parseInt(id)} />
        <DetailsContainer details={namingDetails} />;
        <UsersTable />
      </Sidebar>
    </div>
  );
};

export default ClientRelationships;
